const controllerTypes: Controller.Type[] = [
  "chickenIncubator",
  "aqLight",
]

export function getControllerTypes() {
  return controllerTypes
}